import Echo from 'laravel-echo';
import { getTenantId } from '@/mixins/Helpers'
import Ls from './services/ls'
import io from 'socket.io-client';

window.io = io;
if(window.io){
    window.Echo = new Echo({
        broadcaster: 'socket.io',
        host: getTenantId() + import.meta.env.VITE_APP_SOCKET_URL + ':' + import.meta.env.VITE_APP_SOCKET_PORT,
        auth: {
            headers: {
                Authorization: "Bearer " + Ls.get('auth.token'),
                Accept: "application/json",
                'X-Tenant': getTenantId() ? getTenantId().replace(/\.$/, "") : '',
            },
        },
    });
    
}